var Curriculog = Curriculog || {};

Curriculog.ProposalListItem = (function ($, _, Backbone, ProposalListItem) {

	ProposalListItem = Backbone.View.extend({

		tagName: 'li',
		className: 'open-summary',

		events: {},

		initialize: function(options) {
			this.user = options.user;
			this.params = options.params;

			if (! _.isEmpty(this.model)) {
				this.render();
				this.setElement('#detail-' + this.model.get('id'));
			}
		},

		render: function() {
			var currentStep = _.findWhere(this.model.attributes.steps, {statusText: 'Current'});
			// a proposal cannot be approved when its status are the following
			var disabledStatuses = ['suspended', 'completed', 'deleted', 'unlaunched', 'held'];
			return nunjucks.render('ProposalList/proposalListItem.html',
				{
					proposal: this.model.attributes,
					user: this.user.attributes,
					level: this.params.domParams.get('level'),
					isTaskTab: ( this.params.domParams.get('tab') === 'task' ),
					canApprove: ( disabledStatuses.indexOf(this.model.attributes.status) === -1 ),
					needsSignature: currentStep ? currentStep.signature : 0,
					needsPaperSignature: (this.user.attributes.signatureType === 'paperSignatures' && (currentStep ? currentStep.signature === 1 : false)),
					isUnlaunched: this.model.attributes.status === 'unlaunched',
          cui_enabled: this.params.cui_enabled
				}
			);
		},

	});

	return ProposalListItem;

})($, _, Backbone, Curriculog.ProposalListItem || {});
